import { ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Paper, Typography } from '@mui/material';

import leftCornerIcon from '../../assets/left-corner.svg';
import ArrowIcon from './assets/arrow-right.svg?react';
import { useStyles } from './useStyles';

interface IStakingSectionProps {
  children?: ReactNode;
  isEmpty?: boolean;
  isRed?: boolean;
  title: string;
  titleLink: string;
}

export function StakingSection({
  isEmpty,
  isRed,
  children,
  title,
  titleLink,
}: IStakingSectionProps): ReactElement {
  const { classes, cx } = useStyles();

  const isLink = !!titleLink;
  const linkProps = isLink ? { to: titleLink, component: Link } : {};

  return (
    <Paper className={classes.root}>
      {isRed && (
        <img alt="" className={classes.redCorner} src={leftCornerIcon} />
      )}

      <div
        className={cx(
          classes.content,
          isEmpty ? classes.empty : classes.withContent,
        )}
      >
        <Typography
          className={cx(classes.title, isLink && classes.titleLink)}
          variant="h5"
          {...linkProps}
        >
          {title}

          {isLink && <ArrowIcon className={classes.titleIcon} />}
        </Typography>

        {children}
      </div>
    </Paper>
  );
}
